import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { useStore } from "./state.js";
import { getStorage } from "./helper";

import {
  Routes,
  Route,
  BrowserRouter,
  Link,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";

import reportWebVitals from './reportWebVitals';

import Login from "./routes/login";
import Home from "./routes/home";
import Layout from "./layout";
import PayProcessing from "./routes/processing";
import PayRedirect from "./routes/redirection";


import SwitchAccount from "./routes/switch_account";
import Payment from "./routes/payment";

import Assignments from "./routes/assignments";
import Ledger from "./routes/ledger";
import Invoice from "./routes/invoice";
import CreditNote from "./routes/credit-note";
import ViewInvoice from "./routes/view_invoice";
import ViewReceipt from "./routes/view_receipt";
import ViewCreditNote from "./routes/view_credit_note";
import ViewQuote from "./routes/view_quote";
import Receipt from "./routes/receipt";
import QuickDocs from "./routes/quick_docs";
import QuickPay from "./routes/quick_pay";
import UploadDocs from "./routes/upload_docs";
import Docs from "./modals/doc_request";
import './styles.css';
import NiceModal, { ModalDef, useModal } from '@ebay/nice-modal-react';


if (getStorage('token')) {
  useStore.setState({ auth: 1 });
  //setAuth('1');

}
function AuthRoute({ children }) {
  const auth = useStore((state) => state.auth)
  let location = useLocation();

  if (!auth) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}


function NoMatch() {
  return (
    <div className="text-center mt-5">
      <h2 className="mb-3">Page not found!</h2>
      <p>
        <Link className="btn btn-secondary" to="/">Go to the home page</Link>
      </p>
    </div>
  );
}





export default function App() {

  return (
    <>
      <Routes>

        <Route path="/" element={<AuthRoute><Layout /></AuthRoute>}  >
          <Route path="/" element={<AuthRoute><Home /></AuthRoute>} />

          <Route path="online-payment"  element={<AuthRoute><Payment /></AuthRoute>} />
          <Route path="quick-docs"  element={<AuthRoute><QuickDocs /></AuthRoute>} />
          <Route path="ledger"  element={<AuthRoute><Ledger /></AuthRoute>} />
          <Route path="upload-docs"  element={<AuthRoute><UploadDocs /></AuthRoute>} />
          <Route path="assignments"  element={<AuthRoute><Assignments /></AuthRoute>} />
          <Route path="receipt/:id"  element={<AuthRoute><Receipt /></AuthRoute>} />
          <Route path="invoice/:id"  element={<AuthRoute><Invoice /></AuthRoute>} />
          <Route path="credit-note/:id"  element={<AuthRoute><CreditNote /></AuthRoute>} />
        </Route>
        <Route path="*" element={<NoMatch />} />
        <Route path="/login" element={<Login />} />
        <Route path="/switch-account" element={<AuthRoute><SwitchAccount /></AuthRoute>} />
        <Route path="/view-invoice/:id" element={<ViewInvoice />} />
        <Route path="/view-receipt/:id" element={<ViewReceipt />} />
        <Route path="/view-credit-note/:id" element={<ViewCreditNote />} />
        <Route path="/view-quote/:id" element={<ViewQuote />} />
        <Route path="/quick-pay/:id" element={<QuickPay />} />
        <Route path="/payment-process/:id" element={<PayProcessing />} />
        <Route path="/pay-redirect/:id" element={<PayRedirect />} />
      </Routes>
      <ModalDef id="docs" component={Docs} />
    </>
  );
}





// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
